<h2 mat-dialog-title>
  {{ data.study.studyDescription || 'DICOM Viewer' }}
  <span class="patient-name" *ngIf="data.study.patientName">— {{ data.study.patientName }}</span>
  <button mat-icon-button class="fullscreen-btn" (click)="toggleFullscreen()"
          [matTooltip]="isFullscreen ? 'Exit fullscreen' : 'Fullscreen'">
    <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <div class="viewer-wrapper" [class.fullscreen-mode]="isFullscreen">
    <img *ngIf="imageUrl" [src]="imageUrl" class="dicom-image" alt="DICOM image" />

    <div *ngIf="loading && !error" class="viewer-overlay viewer-loading">
      <mat-progress-spinner diameter="48"></mat-progress-spinner>
      <span>Loading study…</span>
    </div>

    <div *ngIf="error" class="viewer-overlay viewer-error">
      <mat-icon>error_outline</mat-icon>
      <span>{{ error }}</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <span class="instance-counter" *ngIf="totalImages > 1">{{ currentImageNumber }} / {{ totalImages }}</span>
  <button mat-icon-button [disabled]="currentIndex === 0" (click)="goToPrevious()" matTooltip="Previous">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <button mat-icon-button [disabled]="currentIndex >= totalImages - 1" (click)="goToNext()" matTooltip="Next">
    <mat-icon>chevron_right</mat-icon>
  </button>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
